export const APIURL = process.env.REACT_APP_API_URL;
export const NEWAPIURL = process.env.REACT_APP_NEW_API_URL;
export const MSAPIURL = process.env.REACT_APP_MS_API_URL;
